// extracted by mini-css-extract-plugin
export default {"h1":"faq_h1__oWMWz","h2":"faq_h2__M00mJ","h3":"faq_h3__iVXWJ","p":"faq_p__5H+TI"};